















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
// @ts-ignore
import SwaggerUI from '@/components/Documentation/SwaggerUI.vue';

@Component({ name: 'SwaggerUx', components: { SwaggerUI }, metaInfo: { title: 'UX API' } })
export default class extends SaascadaVue {

    get url() {
        return process.env.VUE_APP_UX_BASE_URL + '/openapi';
    }

}
